import * as React from 'react';

function SvgProgressRefunding(props) {
  return (
    <svg width={18} height={18} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M2.39 9.703H3.51c.077 0 .14-.063.14-.14V5.074h9.292V6.35c0 .033.01.065.032.091a.145.145 0 00.154.051.146.146 0 00.051-.026l2.52-1.978c.075-.087.063-.18 0-.232l-2.52-1.975a.149.149 0 00-.239.116v1.276H3.51c-.694 0-1.26.566-1.26 1.262v4.627c0 .077.063.14.14.14zm13.22-1.406H14.49a.141.141 0 00-.14.14v4.488H5.059V11.65a.146.146 0 00-.237-.116l-2.52 1.978c-.075.087-.063.18 0 .232l2.52 1.975a.149.149 0 00.24-.116v-1.276h9.431c.694 0 1.26-.566 1.26-1.262V8.437a.146.146 0 00-.144-.14z" />
    </svg>
  );
}

export default SvgProgressRefunding;
